import React from "react"
import { CheckboxStep } from "#/components/carrot-card-cost-share/steps/variants/CheckboxStep"
import { useIntl } from "react-intl"

export function PleaseConfirmOneThingStep(): JSX.Element {
  const intl = useIntl()

  return (
    <CheckboxStep
      title={intl.formatMessage({ defaultMessage: "Please confirm one thing." })}
      description={intl.formatMessage({ defaultMessage: "We need your confirmation to process your expense." })}
      primaryCheckBoxLabel={intl.formatMessage({
        defaultMessage: "This is a medical expense related to gender-affirming care."
      })}
    />
  )
}
